module.exports = __webpack_public_path__ + "img/52.counter_woman.a2b6f1cc.svg";